import { render } from "./CheckboxPage.vue?vue&type=template&id=7348ec9e&scoped=true"
import script from "./CheckboxPage.vue?vue&type=script&lang=js"
export * from "./CheckboxPage.vue?vue&type=script&lang=js"

import "./CheckboxPage.vue?vue&type=style&index=0&id=7348ec9e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7348ec9e"]])

export default __exports__